import { IconBase, IconComponent } from './BaseIcon';

export const FacebookMessenger: IconComponent = (props) => (
  <IconBase {...props}>
    <path d="M16,2C8.12,2,2,7.8,2,15.6a13.28,13.28,0,0,0,4.4,10,1.13,1.13,0,0,1,.38.8l.07,2.49a1.13,1.13,0,0,0,1.58,1L11.2,28.7a1.08,1.08,0,0,1,.75-.06,15.24,15.24,0,0,0,4.05.54c7.88,0,14-5.78,14-13.58S23.88,2,16,2Zm8.4,10.44L20.29,19a2.1,2.1,0,0,1-3,.56L14,17.1a.84.84,0,0,0-1,0L8.56,20.46a.67.67,0,0,1-1-.89l4.11-6.52a2.1,2.1,0,0,1,3-.56L18,14.94a.83.83,0,0,0,1,0l4.42-3.35A.66.66,0,0,1,24.4,12.47Z" />
  </IconBase>
);
